import { ReactComponent as InfoIcon } from 'components/icons/infoIcon.svg';
import React from 'react';
import styled from 'styled-components';
import { grey } from 'styles/Colors';

export const StrikeZoneDescription = styled.div`
  margin-top: 6px;
`;

export const StrikeZonePriority = styled.div`
  position: absolute;
  bottom: 24px;
  right: 0;
  background-color: rgba(224, 224, 224, 0.1);
  border: 1px solid #e0e0e0;
  padding: 8px;
  font-size: 11px;
  line-height: 10px;
  width: fit-content;
  color: ${grey};
  margin-top: 40px;

  &:hover {
    cursor: pointer;
  }
`;

export const StrikeZoneTitle = styled.div`
  font-weight: 800;
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const StyledInfoIcon = styled((props) => <InfoIcon {...props} />)`
  &:hover {
    cursor: pointer;
  }
`;
